import { render, staticRenderFns } from "./warnScroll.vue?vue&type=template&id=73662976&scoped=true&"
import script from "./warnScroll.vue?vue&type=script&lang=js&"
export * from "./warnScroll.vue?vue&type=script&lang=js&"
import style0 from "./warnScroll.vue?vue&type=style&index=0&id=73662976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73662976",
  null
  
)

export default component.exports